import { inject } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from "@angular/router";
import { AuthService, RoutingService } from "@front/m19-services";
import { map, of, switchMap } from "rxjs";

export const authGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const routingService = inject(RoutingService);

  routingService.setQueryParams(route.queryParams);

  return authService.isLoggedIn().pipe(
    switchMap((loggedIn) => {
      if (loggedIn) {
        return authService.user$;
      }
      return of(undefined);
    }),
    map((user) => {
      if (!user) {
        return router.createUrlTree(["login"], { queryParams: { redirect: state.url } });
      }
      if (!user.registered) {
        return router.createUrlTree(["terms-of-use"]);
      }
      return true;
    }),
  );
};
